import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
const checkoutUrl = 'https://aerial-silks-teacher-ready.impultienda.ar/checkout';
function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Aerial Silks Teacher Ready Complete Package',
    value: 27,
    currency: 'USD'
  });
}
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-138" data-mp="128frrovbsnyc">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-139" data-mp="x9urxqjzk6af" />
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-140" data-mp="s9ghk1uwwk98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-141" data-mp="nbey3ftkqix8">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-142" data-mp="3cz5uuafyvxzt">
            🎓 Aerial Silks Teacher Ready™
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-143" data-mp="3o6khfnpfum7r">
            Solve an entire year of aerial silks classes{' '}
            <span className="text-gold-gradient" data-id="element-144" data-mp="3e8mtl1bhqrfo">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[300px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-145" data-mp="30gzwiz9q5evu">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-146" data-mp="2qleookhz5ke6" />
          <img src="https://cdn.magicpatterns.com/uploads/sCqLmYqzPgx9UMEXMfLXd1/Diseno_sin_titulo_(48).png" alt="Aerial Silks Teacher Ready — 100 ready-to-teach aerial silks classes" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-147" data-mp="2vjzqgocvkc4q" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-148" data-mp="s21hwapu6bzg">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-149" data-mp="najhbnrq6df0">
            100 Ready-to-Teach Aerial Silks Classes with Progressions, Conditioning and Safety Guidance
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-150" data-mp="db2f5gbomhns">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-151" data-mp="1azku1n7lcaq3">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-152" data-mp="x1ee3m2lkvep">
            <div className="flex items-center gap-1.5" data-id="element-153" data-mp="3ltgm7o0v2mna"><CheckCircle size={14} className="text-gold" data-id="element-154" data-mp="3lui9cqv5izld" /><span data-id="element-155" data-mp="3hrlmgnykwhbm">Premium Teaching Library</span></div>
            <div className="flex items-center gap-1.5" data-id="element-156" data-mp="3hpsgzbzpc357"><CheckCircle size={14} className="text-gold" data-id="element-157" data-mp="1x9kugm9v74h7" /><span data-id="element-158" data-mp="1xam9t2xwyd4q">5 Strategic Bonuses</span></div>
            <div className="flex items-center gap-1.5" data-id="element-159" data-mp="21amwtbz2vwne"><CheckCircle size={14} className="text-gold" data-id="element-160" data-mp="21bpm5fgr5r17" /><span data-id="element-161" data-mp="269zihte7qxoe">Immediate Access</span></div>
          </div>
        </motion.div>
      </div>
    </section>;
}